import axios from 'axios';
import getJWT from './token';

const baseApi = `https://api.${process.env.REACT_APP_BASE_URL || "mattk.commerce-ims.com"}`;

export const getOpenSignInsFromApi = async (warehouse, token) => {
    const userToken = await getJWT(token);
    const url = `${baseApi}/carrier-sign-in/sign-ins?open=true&warehouse=${warehouse}`;
    const headers = {
        Authorization: `Bearer ${userToken}`
    };

    const response = await axios.get(url, { headers });
    return response.data;
};

export const sendNewSignInToApi = async (newSignIn, token) => {
    const userToken = await getJWT(token);
    const url = `${baseApi}/carrier-sign-in/sign-ins`;
    const postBody = {
        newSignIn
    };
    
    const headers = {
        Authorization: `Bearer ${userToken}`
    };

    const response = await axios.post(url, postBody, { headers });
    return response;    
};

export const signOutCarrierViaApi = async (signInId, token) => {
    const userToken = await getJWT(token);
    const url = `${baseApi}/carrier-sign-in/sign-ins/${signInId}`;
    const headers = {
        Authorization: `Bearer ${userToken}`
    };

    await axios.put(url, {}, { headers });
};

export const getAllSignInsFromApi = async (token) => {
    const userToken = await getJWT(token);
    const url = `${baseApi}/carrier-sign-in/sign-ins`;
    const headers = {
        Authorization: `Bearer ${userToken}`
    };

    const response = await axios.get(url, { headers });
    return response.data;
};

export const getSignature = async (signInId, token) => {
    const userToken = await getJWT(token);
    const url = `${baseApi}/carrier-sign-in/sign-ins/${signInId}/signature`;
    const headers = {
        Authorization: `Bearer ${userToken}`
    };

    const response = await axios.get(url, { headers });
    return response.data;
};

